
import React from 'react';
import Footer from '../components/Footer';




const Reflexologie = () => {
    return (
        <div>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <div className="container">
                <div className="row text-center">
                    <div className="col-lg-6 offset-lg-3">
                        <div className="about_header mb-5">
                            <span className="top-title">La Réflexologue</span>

                        </div>
                    </div>
                </div>

                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="hero_figure">

                            <img className="imgpage img-reduced" src="assets/img/reflexo_1.jpg" alt="" />

                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="hero_content">

                            <div className="mb-5">
                                <span className="top-title">Qu'est ce que la Réflexologie</span>
                                <br></br>
                                <p>La réflexologie est une pratique de santé complémentaire et naturelle basée sur le fait que le pied ou la main sont des représentations miniaturisées du corps entier à partir duquel il est possible de traiter les organes.
                                    <br></br>Sur les pieds ou les mains se trouvent des zones réflexes, qui sont associées chacune à un organe, une partie du corps ou une glande.
                                    <br></br>

                                    Cette technique combinant massages et acupressions aide le corps à s'auto réguler et à retrouver un équilibre harmonieux.</p>
                                <p></p>
                                Il existe plusieurs types de réflexologies, telles que la réflexologie plantaire, faciale et crânienne...et elles ont toutes le même principe : la projection du corps dans une partie de lui même.
                                <p></p>
                                <p>Cette méthode ne remplace pas le traitement médical mais la complète pour soulager de manière pérenne les nombreux troubles de l'organisme.
                                </p>
                            </div>

                            <a type="button" className="btn btn-lg btn-primary btn-zoom" href="/tarifs">Tarifs</a></div>
                    </div>
                    <p></p>
                    <p></p>
                    <p></p>
                    <br></br>
                    <br></br>
                    <br></br>
                    <div className="container">
                        <div className="row justify-content-between align-items-center">
                            <div className="col-md-6 col-lg-5">
                                <h1 className="top-title">Les bienfaits de la Réflexologie</h1>
                                <p>Les bienfaits sont nombreux, voici quelques uns (liste non exhaustive):</p>
                                <ul className="leaf">
                                    <li><h1 className="top-list">Diminue les effets du stress et de la fatigue</h1></li>
                                    <li><h1 className="top-list">Améliore la circulation sanguine et lymphatique</h1></li>
                                    <li><h1 className="top-list">Renforce le système immunitaire</h1></li>
                                    <li><h1 className="top-list">Détend physiquement et moralement</h1></li>

                                </ul>
                            </div>
                            <div className="col-lg-5 col-md-6">
                                <img src="assets/img/reflexo_2.jpg" className="img-fluid imgpage img-reduced" alt="" />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="container">
                <br></br>
                <br></br>
                <br></br>
                <div className="row text-center">
                    <div className="col-lg-6 offset-lg-3">
                        <div className="about_header mb-5">
                            <span className="top-title">Quand consulter une réflexologue?</span>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-6">


                        <div className="resume__education_item">
                            <p>Migraines, Troubles ORL</p>
                            <p>Affections respiratoires</p>
                            <p>Stress, tensions, fatigue</p>


                        </div>

                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-6">


                        <div className="resume__education_item">
                            <p>Troubles du sommeil</p>
                            <p>Troubles digestifs (maux divers,constipation...)</p>
                            <p>Troubles gynécologiques et urinaires</p>
                        </div>

                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-6">


                        <div className="resume__education_item">
                            <p>Problèmes dermatologiques</p>
                            <p>Douleurs articulaires, musculaires etc</p>
                            <p>En accompagnement de maladies chroniques</p>

                        </div>
                    </div>

                </div>

            </div>

            <Footer />
        </div>

    );
}

export default Reflexologie